import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';

import css from './ListingPage.module.css';
import classNames from 'classnames';

const IconStar = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.starIcon, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 47.94 47.94"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_iconCarrier">
        <path d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,
        1.757 c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,
        1.448-0.742,2.285l2.065,12.042 c0.362,2.109-1.852,3.717-3.746,
        2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685 c-1.894,
        0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528
        c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,
        1.944-1.412l5.407-10.956 C22.602,0.567,25.338,0.567,26.285,2.486z" />
      </g>
    </svg>
  );
};

const IconShield = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.shieldIcon, className);

  return (
    <svg
      className={classes}
      width="40"
      height="40"
      viewBox="0 0 800 800"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M452.184,64.414l-13.12-2.624C378.866,49.751,320.505,29.724,265.538,2.251c-6.004-3.001-13.071-3.001-19.075,0
				C191.478,29.733,133.136,49.754,72.938,61.79l-13.121,2.624c-9.972,1.994-17.149,10.75-17.149,20.919v78.549
				c0,91.952,36.531,180.151,101.544,245.165l96.704,96.704c8.331,8.331,21.839,8.331,30.17,0l96.704-96.704
				c65.014-65.014,101.544-153.213,101.544-245.165V85.333C469.333,75.164,462.156,66.409,452.184,64.414z M426.667,163.883
				c0,80.636-32.036,157.983-89.048,214.995L256,460.497l-81.619-81.619c-57.012-57.012-89.048-134.359-89.048-214.995v-61.072
				C144.359,90.665,201.669,71.279,256,45.097c54.318,26.174,111.642,45.564,170.667,57.714V163.883z" />
      <path d="M185.756,198.244c-8.331-8.331-21.839-8.331-30.17,0s-8.331,21.839,0,30.17l64,64c8.87,8.87,23.443,8.209,31.474-1.428
				l106.667-128c7.543-9.051,6.32-22.503-2.731-30.046c-9.051-7.543-22.503-6.32-30.046,2.731l-91.712,110.054L185.756,198.244z" />
    </svg>
  );
};

const SectionReviews = props => {
  const { reviews, fetchReviewsError } = props;
  let reviewSum = 0;

  reviews.forEach( review => { reviewSum += review.rating });

  return (
    <section className={css.sectionReviews}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <IconStar />
        <FormattedMessage
          id="ListingPage.reviewsTitle"
          values={{ average: reviewSum ? reviewSum / reviews.length : 0, count: reviews.length }}
        />
        <span className={css.hostedByVerifiedHost}>
          &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
          <FormattedMessage id="ListingPage.hostedByVerifiedHost" />
          <IconShield />
        </span>
      </Heading>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}
      <Reviews reviews={reviews} />
    </section>
  );
};

export default SectionReviews;
